/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class MyProfileEmailEditorService {
  // Structure the data correctly so that the api can make sense of it
  static prepareEmailPayload(formGroup: UntypedFormGroup) {
    const result: any = {}

    Object.entries(formGroup.controls).forEach(([ctrlKey, ctrlValue]) => {
      if (ctrlValue instanceof UntypedFormGroup) {
        Object.entries(ctrlValue.value).forEach(([key, value]) => {
          if (value !== null) {
            result[key] = value
          }
        })
      } else {
        if (ctrlValue.value !== null) {
          result[ctrlKey] = ctrlValue.value
        }
      }
    })

    return result
  }
}
